import * as func from "../../api/apiHelper";
import * as urls from "../../api/urlHelper";
import Select from "react-select";
import AsyncSelect from "react-select/async";
import React, { useState, useContext, useEffect } from "react";
import { useFormik, getIn } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MST_MODEL_NAMES } from "../../config/enum";
import { createLoadOptions, selectStyles, formatMstLabel } from "../../utilities";
import { AppContext } from "../context/appContext";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import {
  faChevronLeft,
  faPaperPlane,
  faXmark,
  faPlusCircle,
  faIdCard,
  faSpinner,
} from "@fortawesome/free-solid-svg-icons";
import {
  formSections,
  intialValuesBgProfile,
  yupValidationBgProfile,
  mapProfileDetailsToSchema,
} from "./bgprofileSchema&validation";

const inputCls =
  "no-scroll-input w-full text-sm mt-2 px-3 py-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500";

// The 13 ObjectId-array preference fields rendered as AsyncSelect multiselects.
// Scalar/scope prefs (age window, height range, location) render separately.
const PREFERENCE_MULTISELECT_KEYS = [
  "height", "skinTone", "religion", "caste", "religiousBelief", "motherTongue",
  "familyType", "dietType", "professionSector", "annualIncome", "qualification",
  "star", "gothram",
];

// Mirrors the Spotlight Boost / bg_profile.preferences.locationScope enum.
const LOCATION_SCOPE_OPTIONS = [
  { value: "all_india", label: "All India" },
  { value: "specific_states", label: "Specific states" },
  { value: "nri_all", label: "NRI — anywhere abroad" },
  { value: "nri_specific", label: "NRI — specific countries" },
];

const INDIAN_STATES = [
  "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
  "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
  "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
  "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu",
  "Telangana", "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal",
  "Delhi", "Jammu and Kashmir", "Ladakh", "Puducherry", "Chandigarh",
].map((s) => ({ value: s, label: s }));

const SectionTitle = ({ children }) => (
  <h6 className="text-sm font-semibold text-gray-700 mt-6 mb-3 pb-1 border-b border-gray-100">
    {children}
  </h6>
);

const AddBrideGroomProfile = ({ type }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { matchseekerMasterData } = useContext(AppContext);
  // react-select AsyncSelect snapshots its `defaultOptions` array ONCE on mount.
  // matchseekerMasterData (AppContext) resolves asynchronously AFTER first render,
  // so every context-fed AsyncSelect would freeze with an empty default list until
  // the user types. Deriving a readiness flag and using it as a `key` forces those
  // selects to remount once masters land, re-capturing the populated arrays.
  const mastersReady = Object.keys(matchseekerMasterData || {}).length > 0;
  const [addedBy, setAddedBy] = useState("");
  // Mirror flag for the preferences multiselects, which read `preferncesOptions`
  // (populated by a useEffect that fires AFTER matchseekerMasterData lands — one
  // render later than `mastersReady`). Keying off this avoids remounting a render
  // too early with the options state still empty.
  const [hobbies, setHobbies] = useState([]);
  const [userTypeId, setUserTypeId] = useState("");
  const [preferncesOptions, setPreferencesOptions] = useState({
    height: [],
    skinTone: [],
    caste: [],
    religiousBelief: [],
    motherTongue: [],
    religion: [],
    familyType: [],
    dietType: [],
    professionSector: [],
    annualIncome: [],
    qualification: [],
    star: [],
    gothram: [],
  });
  const prefsReady = Object.values(preferncesOptions).some(
    (arr) => Array.isArray(arr) && arr.length > 0
  );

  const [matchSeekerAndMakerData, setmatchSeekerAndMakerData] = useState({});
  const [profileDetails, setProfileDetails] = useState(intialValuesBgProfile);
  const [step1Data, setStep1Data] = useState({
    phoneNumber: "",
    countryCode: "+91",
    type: "bgprofile",
    profileType: null,
  });

  const [step, setStep] = useState(1);
  const [userIdToken, setUserIdToken] = useState(null);
  const [otpTokenData, setOtpTokenData] = useState({});
  const [otpMessage, setOtpMessage] = useState("");
  const [otp, setOtp] = useState(null);
  const [disableSendOtp, setDisableSendOtp] = useState(false);
  const [profileImagePreview, setProfileImagePreview] = useState(null);
  const [imageGalleryPreviews, setImageGalleryPreviews] = useState([]);

  useEffect(() => {
    const getMatchSeekerAndMakerData = async () => {
      const matchSeekersApiResponse = await func.get(
        urls.GET_ALL_MATCHSEEKERS_URL_NOPAGINATION
      );
      const finalResponse = { matchSeekers: [] };
      if (matchSeekersApiResponse.status === 200) {
        finalResponse.matchSeekers =
          type === "edit"
            ? matchSeekersApiResponse.data?.matchSeekers
            : matchSeekersApiResponse.data?.matchSeekers?.filter(
                (each) => !each.bgProfileExists
              );
      }
      setmatchSeekerAndMakerData(finalResponse);
    };
    getMatchSeekerAndMakerData();
  }, []);

  useEffect(() => {
    if (matchseekerMasterData) {
      setPreferencesOptions({
        height:
          matchseekerMasterData["mst-heights"]?.map((item) => ({
            value: item._id,
            label: item.heights,
          })) || [],
        skinTone:
          matchseekerMasterData["mst-skintone"]?.map((item) => ({
            value: item._id,
            label: item.skintype,
          })) || [],
        religion:
          matchseekerMasterData["mst-religion"]?.map((item) => ({
            value: item._id,
            label: item.religion,
          })) || [],
        caste:
          matchseekerMasterData["mst-caste"]?.map((item) => ({
            value: item._id,
            label: item.caste,
            religionId: item.religionId,
          })) || [],
        motherTongue:
          matchseekerMasterData["mst-language"]?.map((item) => ({
            value: item._id,
            label: item.language,
          })) || [],
        familyType:
          matchseekerMasterData["mst-familytype"]?.map((item) => ({
            value: item._id,
            label: formatMstLabel(item.familyType),
          })) || [],
        dietType:
          matchseekerMasterData["mst-diettype"]?.map((item) => ({
            value: item._id,
            label: formatMstLabel(item.dietType),
          })) || [],
        professionSector:
          matchseekerMasterData["mst-profession-sector"]?.map((item) => ({
            value: item._id,
            label: item.professionSector,
          })) || [],
        annualIncome:
          matchseekerMasterData["mst-annual-income"]?.map((item) => ({
            value: item._id,
            label: item?.["annual Income In(₹)"],
          })) || [],
        qualification:
          matchseekerMasterData["mst-qualification"]?.map((item) => ({
            value: item._id,
            label: item.qualification,
          })) || [],
        star:
          matchseekerMasterData["mst-astrology-star"]?.map((item) => ({
            value: item._id,
            label: item.zodiacSign,
          })) || [],
        gothram:
          matchseekerMasterData["mst-gotram"]?.map((item) => ({
            value: item._id,
            label: item.gotram,
          })) || [],
        religiousBelief:
          matchseekerMasterData["mst-regiousbelief"]?.map((item) => ({
            value: item._id,
            label: item.belief,
          })) || [],
      });
    }
  }, [matchseekerMasterData]);

  const getPreferenceModelName = (preference) => {
    const modelMap = {
      height: "mst-heights",
      skinTone: "mst-skintone",
      religion: "mst-religion",
      caste: "mst-caste",
      motherTongue: "mst-language",
      familyType: "mst-familytype",
      dietType: "mst-diettype",
      professionSector: "mst-profession-sector",
      annualIncome: "mst-annual-income",
      qualification: "mst-qualification",
      star: "mst-astrology-star",
      gothram: "mst-gotram",
      religiousBelief: "mst-regiousbelief",
    };
    return modelMap[preference] || null;
  };

  useEffect(() => {
    if (Object.entries(matchseekerMasterData).length > 0) {
      const modifiedHandI = matchseekerMasterData["mst-hi-categories"].map(
        (eachCategory) => {
          const categoryId = eachCategory._id;
          const relatedSubcategories = matchseekerMasterData[
            "mst-hi-sub-categories"
          ].filter((each) => each.hicategory === categoryId);
          return { ...eachCategory, subCategories: relatedSubcategories };
        }
      );
      setHobbies(modifiedHandI);
    }
  }, [matchseekerMasterData]);

  useEffect(() => {
    const getProfileDetails = async () => {
      const profileDetails = await func.get(
        urls.GET_BGPROFILE_DETAILS_BY_ID_URL + id
      );
      if (profileDetails.status === 200) {
        setUserTypeId(profileDetails.data.data?.ownedBy?._userType?._id);
        setAddedBy(
          profileDetails.data.data?.ownedBy?._userType?.userType ===
            "matchseeker"
            ? "Match Seeker"
            : "Unknown"
        );
        const mappedValues = mapProfileDetailsToSchema(
          profileDetails?.data?.data
        );
        const modifiedProfileDetails = {
          ...mappedValues,
          selectedHobbies: (mappedValues?.selectedHobbies || []).map(
            (h) => h._id
          ),
        };
        setProfileDetails(modifiedProfileDetails);
        setImageGalleryPreviews(profileDetails.data.data?.imageGallery);
      } else {
        toast.error(
          profileDetails?.data?.message || "Failed to load profile details"
        );
      }
    };
    if (type === "edit" && id) getProfileDetails();
  }, [type, id]);

  const formik = useFormik({
    initialValues: type !== undefined ? profileDetails : intialValuesBgProfile,
    enableReinitialize: true,
    validationSchema: yupValidationBgProfile,
    onSubmit: async (values) => {
      try {
        const mobileNumber = values.contactNumber || null;

        if (!values.ownerRelationship) {
          toast.warn("Profile Type is not selected");
          return;
        }
        if (mobileNumber?.length > 0 && userIdToken === null && type !== "edit") {
          toast.warn("Mobile No Not verified");
          return;
        }
        const oldMobileNumber = profileDetails.contactNumber;
        if (
          type === "edit" &&
          mobileNumber?.length > 0 &&
          oldMobileNumber !== mobileNumber &&
          userIdToken === null
        ) {
          toast.warn("Mobile No Changed Please Verify");
          return;
        }

        const { familyDetails } = values;
        const updatedFamilyDetails = {
          fatherDetails: familyDetails.fatherDetails.value,
          motherDetails: familyDetails.motherDetails.value,
          no_of_brothers:
            familyDetails.no_of_brothers === ""
              ? 0
              : parseInt(familyDetails.no_of_brothers),
          no_of_sisters:
            familyDetails.no_of_sisters === ""
              ? 0
              : parseInt(familyDetails.no_of_sisters),
          brothersDetails: familyDetails.brothersDetails.map((each) => ({
            marital_status: each.marital_status === "true",
            occupation: each.occupation?.value,
          })),
          sistersDetails: familyDetails.sistersDetails.map((each) => ({
            isMarried: each.isMarried === "true",
            occupation: each.occupation?.value,
          })),
        };

        const body = {
          isDisabilityExists: values.isDisabilityExists === "true" ? true : false,
          disabilityDetails: values.disabilityDetails,
          accountStatus: values.accountStatus?.value,
          searchingFor: values.searchingFor?.value || "",
          gender: values.searchingFor?.label === "Groom" ? "Female" : "Male",
          firstName: values.firstName,
          dateOfBirth: values.dateOfBirth,
          height: values.height?.value || "",
          skinTone: values.skinTone?.value || "",
          profileImage: values.profileImage,
          imageGallery: values?.imageGallery
            ? values.imageGallery.filter((value) => value !== null)
            : [],
          religion: values.religion?.value || "",
          caste: values.caste?.value || "",
          subCaste: values.subCaste || "",
          religiousBelief: values.religiousBelief?.value || "",
          motherTongue: values.motherTongue?.value || "",
          qualification: values.qualification?.value || "",
          fieldOfStudy: values.fieldOfStudy?.value || "",
          professionSector: values.professionSector?.value || "",
          organizationName: values.organizationName,
          professionalDesignation: values.professionalDesignation?.value || "",
          annualIncome: values.annualIncome?.value || "",
          familyType: values.familyType?.value || "",
          dietType: values.dietType?.value || "",
          familyName: values.familyName,
          star: values.star?.value || null,
          nakshatra: values.nakshatra?.value || null,
          raashi: values.raashi?.value || null,
          dosha: values.dosha?.value || null,
          gothram: values.gothram?.value || null,
          contactNumber: values.contactNumber,
          residentLocation: values.residentLocation?.value || "",
          birthLocation: values.birthLocation?.value || "",
          ownedBy: values.ownedBy?.value || "",
          userTypeid: userTypeId,
          selectedHobbies: values.selectedHobbies,
          ownerRelationship: values?.ownerRelationship?.value || null,
          bodyType: values?.bodyType?.value,
          weight: values?.weight,
          preferences: {
            height: values.preferences.height?.map((item) => item.value) || [],
            skinTone:
              values.preferences.skinTone?.map((item) => item.value) || [],
            caste: values.preferences.caste?.map((item) => item.value) || [],
            subCaste: values.preferences.subCaste || [],
            motherTongue:
              values.preferences.motherTongue?.map((item) => item.value) || [],
            religion:
              values.preferences.religion?.map((item) => item.value) || [],
            familyType:
              values.preferences.familyType?.map((item) => item.value) || [],
            dietType:
              values.preferences.dietType?.map((item) => item.value) || [],
            professionSector:
              values.preferences.professionSector?.map((item) => item.value) || [],
            annualIncome:
              values.preferences.annualIncome?.map((item) => item.value) || [],
            qualification:
              values.preferences.qualification?.map((item) => item.value) || [],
            star: values.preferences.star?.map((item) => item.value) || [],
            gothram: values.preferences.gothram?.map((item) => item.value) || [],
            religiousBelief:
              values.preferences.religiousBelief?.map((item) => item.value) || [],
            // Scalar / scope prefs — "" → null so the backend treats a blank as
            // "clear/open" rather than rejecting it. Backend re-validates ranges.
            minAge: values.preferences.minAge === "" ? null : Number(values.preferences.minAge),
            maxAge: values.preferences.maxAge === "" ? null : Number(values.preferences.maxAge),
            minHeightCm:
              values.preferences.minHeightCm === "" ? null : Number(values.preferences.minHeightCm),
            maxHeightCm:
              values.preferences.maxHeightCm === "" ? null : Number(values.preferences.maxHeightCm),
            locationScope: values.preferences.locationScope || null,
            targetStates: values.preferences.targetStates || [],
          },
          familyDetails: updatedFamilyDetails,
          _aadharUserDetails: values?._aadharUserDetails || {},
          _last4Digits: values?._last4Digits || "",
        };

        const apiCall =
          type === "edit"
            ? func.put(urls.EDIT_BGPROFILE_URL + id, body)
            : func.post(urls.ADD_BG_PROFILE_URL, body);

        const profileApiResponse = await apiCall;

        if (profileApiResponse.status === 201) {
          toast.success(`Profile ${type === "edit" ? "Updated" : "Added"} Successfully`);
          navigate("/user-management/bride-groom-profile/list");
        } else {
          toast.warn(
            profileApiResponse?.data?.message || "Failed to save profile"
          );
        }
      } catch (err) {
        toast.error(err?.response?.data?.message || err?.message || "Something went wrong");
      }
    },
  });

  const handleProfileImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const validTypes = ["image/jpeg", "image/png"];
      if (!validTypes.includes(file.type)) {
        toast.error("Invalid file type. Please upload an image in JPG or PNG format.");
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        setProfileImagePreview(reader.result);
        formik.setFieldValue("profileImage", reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleImageGalleryUpload = (event, index) => {
    const file = event.target.files[0];
    if (file) {
      const validTypes = ["image/jpeg", "image/png"];
      if (!validTypes.includes(file.type)) {
        toast.error("Invalid file type. Please upload an image in JPG or PNG format.");
        return;
      }
      const reader = new FileReader();
      reader.onloadend = () => {
        const newGallery = [...imageGalleryPreviews];
        newGallery[index] = reader.result;
        setImageGalleryPreviews(newGallery);
        formik.setFieldValue("imageGallery", newGallery);
      };
      reader.readAsDataURL(file);
      event.target.value = null;
    }
  };

  const getPreferenceOptions = (preference) => {
    if (preference === "caste") {
      const religionIds = (formik.values.preferences.religion || []).map(
        (each) => each.value
      );
      // No religion preference chosen yet → show every caste rather than an
      // empty list (the old behaviour made the dropdown look broken). Once a
      // religion preference is selected, narrow to that religion's castes.
      if (religionIds.length === 0) return preferncesOptions["caste"];
      return preferncesOptions["caste"].filter((caste) =>
        religionIds.includes(caste.religionId)
      );
    }
    return preferncesOptions[preference];
  };

  const getOptions = (key) => {
    if (!matchseekerMasterData || !matchseekerMasterData[key]) return [];
    return matchseekerMasterData[key].map((item) => ({
      value: item._id,
      label:
        item.name ||
        item?.["annual Income In(₹)"] ||
        item.religion ||
        item.caste ||
        item.zodiacSign ||
        item.city ||
        formatMstLabel(item.dietType) ||
        formatMstLabel(item.familyType) ||
        item.gotram ||
        item.heights ||
        item.language ||
        item.profession ||
        item.professionSector ||
        item.qualification ||
        item.belief ||
        item.skintype ||
        item.subcaste ||
        item.gender ||
        item.raashi ||
        item.nakshatra ||
        formatMstLabel(item.motherDetails) ||
        formatMstLabel(item.fatherDetails) ||
        item.designation ||
        item.matchFor ||
        item.dosha ||
        item.bodytype,
    }));
  };

  const handleSendOtp = async () => {
    setDisableSendOtp(true);
    try {
      const mobileNumber = step1Data.phoneNumber;
      const oldMobileNumber = profileDetails.contactNumber;
      if (type === "edit" && oldMobileNumber === mobileNumber) {
        setStep(3);
        return toast.warn("Verification Not Required");
      }
      const sendOtpApiresponse = await func.post(urls.CHECK_PHONE_NO_URL, step1Data);
      if (
        sendOtpApiresponse.status === 200 &&
        sendOtpApiresponse.statusText === "OK"
      ) {
        toast.success(`OTP sent successfully to ${step1Data.phoneNumber}`);
        toast.info(sendOtpApiresponse.data.otp);
        setOtpTokenData(sendOtpApiresponse.data);
        setOtpMessage(`Enter the OTP sent to: ${step1Data.phoneNumber}`);
        setStep(2);
      } else {
        toast.warn(sendOtpApiresponse?.data?.message || "Failed to send OTP");
        setStep(1);
        setOtp(null);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.message || "Failed to send OTP");
      setStep(1);
      setOtp(null);
    } finally {
      setDisableSendOtp(false);
    }
  };

  const handleVerifyOtp = async () => {
    try {
      const verifyOtpApiResponse = await func.post(urls.VERIFY_OTP_BG_PROFILE_URL, {
        hashedOtpToken: otpTokenData.token,
        otp,
      });
      if (
        (verifyOtpApiResponse.status === 200 &&
          verifyOtpApiResponse.statusText === "OK") ||
        (verifyOtpApiResponse.status === 201 &&
          verifyOtpApiResponse.statusText === "Created")
      ) {
        setUserIdToken(verifyOtpApiResponse.data);
        toast.success("OTP Verified Successfully");
        setOtp(null);
        setStep(3);
      } else {
        toast.warn(
          verifyOtpApiResponse?.data?.message || "OTP verification failed"
        );
        setOtp(null);
        setStep(1);
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || err?.message || "OTP verification failed");
      setOtp(null);
      setStep(1);
    }
  };

  const handleDeleteImage = (index) => {
    const updatedPreviews = [...imageGalleryPreviews];
    updatedPreviews[index] = null;
    setImageGalleryPreviews(updatedPreviews);
    const updatedProfileImages = [...profileDetails.imageGallery];
    updatedProfileImages[index] = null;
    setProfileDetails({ ...profileDetails, imageGallery: updatedProfileImages });
  };

  return (
    <div className="mt-12 p-2 bg-[linear-gradient(to_left,_#19224B,_#E2B865)] min-h-[90vh] rounded-lg">
      <div className="max-w-5xl mx-auto min-h-[80vh] bg-white rounded-xl shadow-sm p-8 mt-4">

        {/* Header */}
        <div className="flex items-center gap-3 mb-6">
          <button
            onClick={() => navigate(-1)}
            className="text-gray-400 hover:text-gray-600 transition"
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>
          <FontAwesomeIcon icon={faIdCard} className="text-indigo-400" />
          <h4 className="text-base font-semibold text-gray-800">
            {type === "edit" ? "Edit" : "Add"} Bride / Groom Profile
          </h4>
        </div>

        {/* Owner & Profile Type */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <label htmlFor="ownedBy" className="block text-xs font-medium text-gray-600 mb-1">
              Select Matchseeker (Mobile No) <span className="text-red-500">*</span>
            </label>
            <Select
              inputId="ownedBy"
              name="ownedBy"
              isMulti={false}
              options={
                matchSeekerAndMakerData?.matchSeekers?.map((each) => ({
                  ...each,
                  label: each?.userId?._phoneNumber,
                  value: each?.userId?._id,
                  userType: each?.userId?._userType,
                })) || []
              }
              value={formik.values.ownedBy || null}
              onChange={(e) => {
                formik.setFieldValue("ownedBy", e);
                setUserTypeId(e.userType);
              }}
              placeholder="Select Match Seeker"
            />
            {formik.errors.ownedBy && formik.touched.ownedBy && (
              <p className="text-xs text-red-500 mt-1">{formik.errors.ownedBy}</p>
            )}
          </div>

          <div>
            <label htmlFor="ownerRelationship" className="block text-xs font-medium text-gray-600 mb-1">
              Profile Type <span className="text-red-500">*</span>
            </label>
            <AsyncSelect
              key={`ownerRelationship-${mastersReady}`}
              inputId="ownerRelationship"
              placeholder="Select Owner Relationship"
              isClearable
              cacheOptions
              styles={selectStyles}
              loadOptions={createLoadOptions(MST_MODEL_NAMES[3])}
              defaultOptions={(matchseekerMasterData["mst-findmatchfor"] || [])
                .map((r) => ({ value: r._id, label: r.matchFor }))}
              value={formik.values.ownerRelationship}
              onChange={(selectedOption) =>
                formik.setFieldValue("ownerRelationship", selectedOption)
              }
            />
            {formik.errors.ownerRelationship && formik.touched.ownerRelationship && (
              <p className="text-xs text-red-500 mt-1">
                {formik.errors.ownerRelationship}
              </p>
            )}
          </div>
        </div>

        {/* Profile Image */}
        <SectionTitle>Profile Image <span className="text-red-500">*</span></SectionTitle>
        <div className="mb-6">
          <div
            className="w-32 h-32 rounded-full border-2 border-gray-300 flex items-center justify-center cursor-pointer overflow-hidden"
            style={{
              backgroundImage: profileImagePreview
                ? `url(${profileImagePreview})`
                : profileDetails.profileImage
                ? `url(${profileDetails.profileImage})`
                : "none",
              backgroundSize: "cover",
              backgroundPosition: "center",
            }}
            onClick={() => document.getElementById("profileImageInput").click()}
          >
            {!profileImagePreview && !profileDetails.profileImage && (
              <FontAwesomeIcon icon={faPlusCircle} className="text-gray-400 text-2xl" />
            )}
          </div>
          <input
            type="file"
            id="profileImageInput"
            accept="image/*"
            className="hidden"
            onChange={handleProfileImageUpload}
          />
          {formik.errors.profileImage && formik.touched.profileImage && (
            <p className="text-xs text-red-500 mt-1">{formik.errors.profileImage}</p>
          )}
        </div>

        {/* Image Gallery */}
        <SectionTitle>Image Gallery</SectionTitle>
        <div className="mb-6">
          <div className="grid grid-cols-3 md:grid-cols-6 gap-4">
            {Array(6)
              .fill(null)
              .map((_, index) => (
                <div key={index} className="relative w-24 h-24 md:w-28 md:h-28">
                  {(imageGalleryPreviews[index] ||
                    profileDetails.imageGallery[index]) && (
                    <button
                      className="absolute -top-1 -right-1 bg-red-500 text-white rounded-full w-5 h-5 flex items-center justify-center hover:bg-red-700 shadow-md z-10"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleDeleteImage(index);
                      }}
                    >
                      <FontAwesomeIcon icon={faXmark} size="xs" />
                    </button>
                  )}
                  <div
                    className="w-full h-full rounded-full border-2 border-gray-300 flex items-center justify-center cursor-pointer overflow-hidden"
                    style={{
                      backgroundImage: imageGalleryPreviews[index]
                        ? `url(${imageGalleryPreviews[index]})`
                        : profileDetails.imageGallery[index]
                        ? `url(${profileDetails.imageGallery[index]})`
                        : "none",
                      backgroundSize: "cover",
                      backgroundPosition: "center",
                    }}
                    onClick={() =>
                      !imageGalleryPreviews[index] &&
                      !profileDetails.imageGallery[index] &&
                      document.getElementById(`galleryInput-${index}`).click()
                    }
                  >
                    {!imageGalleryPreviews[index] &&
                      !profileDetails.imageGallery[index] && (
                        <FontAwesomeIcon
                          icon={faPlusCircle}
                          className="text-gray-400 text-xl"
                        />
                      )}
                    <input
                      type="file"
                      id={`galleryInput-${index}`}
                      accept="image/*"
                      className="hidden"
                      onChange={(e) => handleImageGalleryUpload(e, index)}
                    />
                  </div>
                </div>
              ))}
          </div>
          {formik.errors.imageGallery && formik.touched.imageGallery && (
            <p className="text-xs text-red-500 mt-2">{formik.errors.imageGallery}</p>
          )}
        </div>

        {/* Dynamic Form Sections */}
        {formSections.map((section, sectionIndex) => (
          <div key={sectionIndex}>
            <SectionTitle>{section.title}</SectionTitle>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
              {section.fields.map((field, fieldIndex) => (
                <div key={fieldIndex} className="col-span-1">
                  <label
                    htmlFor={field.name}
                    className="block text-xs font-medium text-gray-600 mb-1"
                  >
                    {field.label}{" "}
                    {field?.required && <span className="text-red-500">*</span>}
                  </label>

                  {field.type === "select" && field?.options?.length > 0 ? (
                    <select
                      id={field.name}
                      name={field.name}
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={getIn(formik.values, field.name)}
                      className={inputCls}
                    >
                      <option value="" disabled>
                        {field.placeholder || "Select an option"}
                      </option>
                      {field.options.map((option) => (
                        <option key={option.value} value={option.value}>
                          {option.label}
                        </option>
                      ))}
                    </select>
                  ) : field.type === "select" ? (
                    <AsyncSelect
                      key={`${field.name}-${mastersReady}-${
                        field.name === "caste"
                          ? formik.values?.religion?.value || ""
                          : ""
                      }`}
                      placeholder={field.placeholder}
                      isClearable={section.title === "Astrology Details"}
                      cacheOptions
                      styles={selectStyles}
                      className="mt-1"
                      defaultOptions={
                        field.name === "caste"
                          ? (matchseekerMasterData[field.key] || []).reduce(
                              (acc, caste) => {
                                if (
                                  acc.length < 10 &&
                                  caste?.religionId ===
                                    formik.values?.religion?.value
                                ) {
                                  acc.push({ value: caste._id, label: caste.caste });
                                }
                                return acc;
                              },
                              []
                            )
                          : getOptions(field.key)?.slice(0, 5)
                      }
                      loadOptions={
                        field.name === "caste"
                          ? createLoadOptions(
                              field.key,
                              50,
                              formik.values?.religion?.value
                            )
                          : createLoadOptions(field.key)
                      }
                      value={getIn(formik.values, field.name)}
                      onChange={(selectedOption) => {
                        formik.setFieldValue(field.name, selectedOption);
                        if (field.name === "religion") {
                          formik.setFieldValue("caste", null);
                        }
                      }}
                    />
                  ) : (
                    <>
                      <input
                        id={field.name}
                        type={field.type}
                        name={field.name}
                        value={getIn(formik.values, field.name)}
                        onChange={(e) => {
                          formik.setFieldValue(field.name, e.target.value);
                          if (field.name === "contactNumber") {
                            setStep1Data({ ...step1Data, phoneNumber: e.target.value });
                            setStep(1);
                          }
                        }}
                        onInput={(e) => {
                          if (
                            field.name === "familyDetails.no_of_brothers" ||
                            field.name === "familyDetails.no_of_sisters"
                          ) {
                            e.target.value = e.target.value
                              .replace(/\D/g, "")
                              .slice(0, 2);
                            if (parseInt(e.target.value) > 10) {
                              e.target.value = "10";
                            }
                          } else if (field.name === "subCaste") {
                            e.target.value = e.target.value.replace(
                              /[^a-zA-Z\s]/g,
                              ""
                            );
                          }
                        }}
                        onBlur={(e) => {
                          const { name, value } = e.target;
                          let numericValue = parseInt(value, 10);
                          if (isNaN(numericValue) || numericValue < 0) {
                            numericValue = 0;
                          }
                          if (name === "familyDetails.no_of_brothers") {
                            const currentBrothers =
                              formik.values.familyDetails.brothersDetails || [];
                            const newBrothers = Array.from(
                              { length: numericValue },
                              (_, i) =>
                                currentBrothers[i] || {
                                  marital_status: "",
                                  occupation: "",
                                }
                            );
                            formik.setFieldValue(
                              "familyDetails.brothersDetails",
                              newBrothers
                            );
                            formik.validateField(field.name);
                          }
                          if (name === "familyDetails.no_of_sisters") {
                            const currentSisters =
                              formik.values.familyDetails.sistersDetails || [];
                            const newSisters = Array.from(
                              { length: numericValue },
                              (_, i) =>
                                currentSisters[i] || { isMarried: "", occupation: "" }
                            );
                            formik.setFieldValue(
                              "familyDetails.sistersDetails",
                              newSisters
                            );
                          }
                        }}
                        className={inputCls}
                        placeholder={field.placeholder}
                        onWheel={(e) => e.target.blur()}
                      />

                      {step1Data.phoneNumber.length === 10 &&
                        step === 1 &&
                        field.name === "contactNumber" &&
                        !formik.errors["contactNumber"] && (
                          <div className="flex justify-end mt-1">
                            <button
                              disabled={disableSendOtp}
                              onClick={handleSendOtp}
                              className="bg-indigo-600 text-white py-1 px-3 text-xs rounded-md hover:bg-indigo-700 disabled:opacity-50 transition"
                            >
                              Send OTP
                            </button>
                          </div>
                        )}
                    </>
                  )}

                  {/* OTP Input */}
                  {step === 2 && field.name === "contactNumber" && (
                    <div className="mt-3 p-3 bg-indigo-50 rounded-lg border border-indigo-100">
                      <label htmlFor="otp-input" className="block text-xs font-medium text-gray-600 mb-1">
                        Enter OTP
                      </label>
                      <input
                        id="otp-input"
                        type="text"
                        value={otp}
                        disabled={step !== 2}
                        onChange={(e) => setOtp(e.target.value)}
                        onInput={(e) => {
                          e.target.value = e.target.value.replace(/\D/g, "").slice(0, 4);
                        }}
                        className={inputCls}
                        placeholder="Enter OTP"
                      />
                      {otpMessage && (
                        <p className="mt-1 text-xs text-green-600 font-medium">
                          {otpMessage}
                        </p>
                      )}
                      {otp?.length === 4 && (
                        <div className="flex justify-end mt-2">
                          <button
                            onClick={handleVerifyOtp}
                            className="bg-indigo-600 text-white py-1.5 px-4 text-xs rounded-md hover:bg-indigo-700 transition"
                          >
                            Verify OTP
                          </button>
                        </div>
                      )}
                    </div>
                  )}

                  {getIn(formik.errors, field.name) && (
                    <p className="text-xs text-red-500 mt-1">
                      {getIn(formik.errors, field.name)}
                    </p>
                  )}
                </div>
              ))}
            </div>

            {section.title === "Personal Details" && (
              <div className="mt-4">
                <p className="text-xs font-medium text-gray-600 mb-2">
                  Do You have a Disability or Medical Condition?
                </p>
                <div className="flex gap-4">
                  <label className="flex items-center gap-2 cursor-pointer text-sm">
                    <input
                      type="radio"
                      name="isDisabilityExists"
                      value="true"
                      checked={formik.values.isDisabilityExists === "true"}
                      onChange={() =>
                        formik.setFieldValue("isDisabilityExists", "true")
                      }
                    />
                    Yes
                  </label>
                  <label className="flex items-center gap-2 cursor-pointer text-sm">
                    <input
                      type="radio"
                      name="isDisabilityExists"
                      value="false"
                      checked={formik.values.isDisabilityExists === "false"}
                      onChange={() => {
                        formik.setFieldValue("disabilityDetails", "");
                        formik.setFieldValue("isDisabilityExists", "false");
                      }}
                    />
                    No
                  </label>
                </div>
                {formik.errors.isDisabilityExists &&
                  formik.touched.isDisabilityExists && (
                    <p className="text-xs text-red-500 mt-1">
                      {formik.errors.isDisabilityExists}
                    </p>
                  )}
                {formik.values.isDisabilityExists === "true" && (
                  <div className="mt-3">
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Disability Details
                    </label>
                    <p className="flex items-start gap-2 text-xs text-indigo-700 italic bg-indigo-50 p-3 rounded-md mb-2">
                      <span className="text-base leading-none">ⓘ</span>
                      Please let us know of any health conditions or disabilities that
                      impact your daily life. Sharing this information allows us to
                      connect you with a partner who values inclusivity and support.
                    </p>
                    <textarea
                      className={inputCls}
                      name="disabilityDetails"
                      onChange={formik.handleChange}
                      rows="4"
                      value={formik.values.disabilityDetails}
                      placeholder="Enter Disability / Medical Condition details"
                    />
                    {formik.errors.disabilityDetails &&
                      formik.touched.disabilityDetails && (
                        <p className="text-xs text-red-500 mt-1">
                          {formik.errors.disabilityDetails}
                        </p>
                      )}
                  </div>
                )}
              </div>
            )}
          </div>
        ))}

        {/* Brother / Sister Repeaters */}
        {formik.values.familyDetails?.no_of_brothers > 0 && (
          <div className="mt-6">
            <SectionTitle>Brother Details</SectionTitle>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {Array.from({
                length: Math.min(formik.values.familyDetails.no_of_brothers, 10),
              }).map((_, index) => (
                <div key={index} className="border border-gray-200 p-4 rounded-lg shadow-sm">
                  <h5 className="text-sm font-semibold text-gray-700 mb-3">
                    Brother {index + 1}
                  </h5>
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Marital Status
                    </label>
                    <select
                      name={`familyDetails.brothersDetails[${index}].marital_status`}
                      value={
                        formik.values.familyDetails.brothersDetails[index]
                          ?.marital_status || ""
                      }
                      onChange={formik.handleChange}
                      className={inputCls}
                    >
                      <option value="">Select Marital Status</option>
                      <option value="true">Married</option>
                      <option value="false">Unmarried</option>
                    </select>
                    {formik.errors.familyDetails?.brothersDetails?.[index]
                      ?.marital_status &&
                      formik.touched.familyDetails?.brothersDetails?.[index]
                        ?.marital_status && (
                        <p className="text-xs text-red-500 mt-1">
                          {
                            formik.errors.familyDetails.brothersDetails[index]
                              .marital_status
                          }
                        </p>
                      )}
                  </div>
                  <div className="mt-3">
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Occupation
                    </label>
                    <AsyncSelect
                      key={`brother-occupation-${index}-${mastersReady}`}
                      placeholder="Select Occupation"
                      isClearable
                      cacheOptions
                      styles={selectStyles}
                      loadOptions={createLoadOptions(MST_MODEL_NAMES[29])}
                      defaultOptions={getOptions("mst-designation")?.slice(0, 5)}
                      value={
                        formik.values.familyDetails.brothersDetails[index]
                          ?.occupation || ""
                      }
                      onChange={(selectedOption) =>
                        formik.setFieldValue(
                          `familyDetails.brothersDetails[${index}].occupation`,
                          selectedOption
                        )
                      }
                    />
                    {getIn(
                      formik.errors,
                      `familyDetails.brothersDetails.${index}.occupation`
                    ) && (
                      <p className="text-xs text-red-500 mt-1">
                        {getIn(
                          formik.errors,
                          `familyDetails.brothersDetails.${index}.occupation`
                        )}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {formik.values.familyDetails?.no_of_sisters > 0 && (
          <div className="mt-6">
            <SectionTitle>Sister Details</SectionTitle>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {Array.from({
                length: Math.min(formik.values.familyDetails.no_of_sisters, 10),
              }).map((_, index) => (
                <div key={index} className="border border-gray-200 p-4 rounded-lg shadow-sm">
                  <h5 className="text-sm font-semibold text-gray-700 mb-3">
                    Sister {index + 1}
                  </h5>
                  <div>
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Marital Status
                    </label>
                    <select
                      name={`familyDetails.sistersDetails[${index}].isMarried`}
                      value={
                        formik.values.familyDetails.sistersDetails[index]
                          ?.isMarried || ""
                      }
                      onChange={formik.handleChange}
                      className={inputCls}
                    >
                      <option value="">Select Marital Status</option>
                      <option value="true">Married</option>
                      <option value="false">Unmarried</option>
                    </select>
                    {formik.errors.familyDetails?.sistersDetails?.[index]
                      ?.isMarried && (
                      <p className="text-xs text-red-500 mt-1">
                        {
                          formik.errors.familyDetails.sistersDetails[index]
                            .isMarried
                        }
                      </p>
                    )}
                  </div>
                  <div className="mt-3">
                    <label className="block text-xs font-medium text-gray-600 mb-1">
                      Occupation
                    </label>
                    <AsyncSelect
                      key={`sister-occupation-${index}-${mastersReady}`}
                      placeholder="Select Occupation"
                      isClearable
                      cacheOptions
                      styles={selectStyles}
                      loadOptions={createLoadOptions(MST_MODEL_NAMES[29])}
                      defaultOptions={getOptions("mst-designation")?.slice(0, 5)}
                      value={
                        formik.values.familyDetails.sistersDetails[index]
                          ?.occupation || ""
                      }
                      onChange={(selectedOption) =>
                        formik.setFieldValue(
                          `familyDetails.sistersDetails[${index}].occupation`,
                          selectedOption
                        )
                      }
                    />
                    {getIn(
                      formik.errors,
                      `familyDetails.sisterDetails.${index}.occupation`
                    ) && (
                      <p className="text-xs text-red-500 mt-1">
                        {getIn(
                          formik.errors,
                          `familyDetails.sisterDetails.${index}.occupation`
                        )}
                      </p>
                    )}
                  </div>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Preferences */}
        <SectionTitle>Preferences</SectionTitle>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
          {PREFERENCE_MULTISELECT_KEYS.map((eachPreference) => (
            <div key={eachPreference} className="col-span-1">
              <label className="block text-xs font-medium text-gray-600 mb-1">
                {eachPreference
                  .replace(/([A-Z])/g, " $1")
                  .replace(/^./, (str) => str.toUpperCase())}
              </label>
              <AsyncSelect
                key={`pref-${eachPreference}-${prefsReady}-${
                  eachPreference === "caste"
                    ? (formik.values.preferences.religion || [])
                        .map((r) => r.value)
                        .join(",")
                    : ""
                }`}
                isMulti
                isClearable
                name={`preferences.${eachPreference}`}
                placeholder={`Select ${eachPreference}`}
                cacheOptions
                defaultOptions={getPreferenceOptions(eachPreference) || []}
                styles={selectStyles}
                loadOptions={createLoadOptions(getPreferenceModelName(eachPreference))}
                value={formik.values.preferences[eachPreference] || []}
                onChange={(selectedOptions) =>
                  formik.setFieldValue(
                    `preferences.${eachPreference}`,
                    selectedOptions || []
                  )
                }
                className="mt-1"
              />
              {eachPreference === "caste" &&
                (formik.values.preferences.religion || []).length === 0 && (
                  <p className="text-xs text-gray-400 mt-1">
                    Select a religion preference to narrow castes (showing all for now).
                  </p>
                )}
              {formik.errors.preferences?.[eachPreference] &&
                formik.touched.preferences?.[eachPreference] && (
                  <p className="text-xs text-red-500 mt-1">
                    {formik.errors.preferences[eachPreference]}
                  </p>
                )}
            </div>
          ))}
        </div>

        {/* Match window — age, height range, location scope (mirrors the app) */}
        <SectionTitle>Match Window</SectionTitle>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
          {/* Age window */}
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">
              Partner age (years)
            </label>
            <div className="flex items-center gap-2">
              <input
                type="number"
                min={18}
                max={75}
                placeholder="Min"
                className={inputCls}
                value={formik.values.preferences.minAge}
                onChange={(e) =>
                  formik.setFieldValue("preferences.minAge", e.target.value)
                }
              />
              <span className="text-gray-400">–</span>
              <input
                type="number"
                min={18}
                max={75}
                placeholder="Max"
                className={inputCls}
                value={formik.values.preferences.maxAge}
                onChange={(e) =>
                  formik.setFieldValue("preferences.maxAge", e.target.value)
                }
              />
            </div>
            {(formik.errors.preferences?.minAge || formik.errors.preferences?.maxAge) && (
              <p className="text-xs text-red-500 mt-1">
                {formik.errors.preferences.minAge || formik.errors.preferences.maxAge}
              </p>
            )}
          </div>

          {/* Height range (cm) */}
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">
              Partner height (cm)
            </label>
            <div className="flex items-center gap-2">
              <input
                type="number"
                min={120}
                max={215}
                placeholder="Min"
                className={inputCls}
                value={formik.values.preferences.minHeightCm}
                onChange={(e) =>
                  formik.setFieldValue("preferences.minHeightCm", e.target.value)
                }
              />
              <span className="text-gray-400">–</span>
              <input
                type="number"
                min={120}
                max={215}
                placeholder="Max"
                className={inputCls}
                value={formik.values.preferences.maxHeightCm}
                onChange={(e) =>
                  formik.setFieldValue("preferences.maxHeightCm", e.target.value)
                }
              />
            </div>
            {(formik.errors.preferences?.minHeightCm ||
              formik.errors.preferences?.maxHeightCm) && (
              <p className="text-xs text-red-500 mt-1">
                {formik.errors.preferences.minHeightCm ||
                  formik.errors.preferences.maxHeightCm}
              </p>
            )}
          </div>

          {/* Location scope */}
          <div>
            <label className="block text-xs font-medium text-gray-600 mb-1">
              Location scope
            </label>
            <Select
              isClearable
              name="preferences.locationScope"
              placeholder="Select location scope"
              options={LOCATION_SCOPE_OPTIONS}
              styles={selectStyles}
              value={
                LOCATION_SCOPE_OPTIONS.find(
                  (o) => o.value === formik.values.preferences.locationScope
                ) || null
              }
              onChange={(opt) =>
                formik.setFieldValue("preferences.locationScope", opt?.value || null)
              }
              className="mt-1"
            />
            {formik.values.preferences.locationScope === "specific_states" && (
              <div className="mt-3">
                <label className="block text-xs font-medium text-gray-600 mb-1">
                  Target states
                </label>
                <Select
                  isMulti
                  isClearable
                  name="preferences.targetStates"
                  placeholder="Select states"
                  options={INDIAN_STATES}
                  styles={selectStyles}
                  value={(formik.values.preferences.targetStates || []).map((s) => ({
                    value: s,
                    label: s,
                  }))}
                  onChange={(opts) =>
                    formik.setFieldValue(
                      "preferences.targetStates",
                      (opts || []).map((o) => o.value)
                    )
                  }
                />
              </div>
            )}
          </div>
        </div>

        {/* Account Status */}
        <SectionTitle>Status</SectionTitle>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-sm">
          <div>
            <label htmlFor="accountStatus" className="block text-xs font-medium text-gray-600 mb-1">
              Account Status
            </label>
            <Select
              inputId="accountStatus"
              name="accountStatus"
              options={[
                { label: "ACTIVE", value: "ACTIVE" },
                { label: "INACTIVE", value: "INACTIVE" },
              ]}
              value={formik.values?.accountStatus}
              onChange={(e) => formik.setFieldValue("accountStatus", e)}
              placeholder="Select Account Status"
            />
            {formik.errors.accountStatus && formik.touched.accountStatus && (
              <p className="text-xs text-red-500 mt-1">
                {formik.errors.accountStatus}
              </p>
            )}
          </div>
        </div>

        {/* Hobbies & Interests */}
        {hobbies.length > 0 && (
          <>
            <SectionTitle>Hobbies and Interests</SectionTitle>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 text-sm mb-4">
              {hobbies.map(
                (category, categoryIndex) =>
                  category.subCategories.length > 0 && (
                    <div
                      key={categoryIndex}
                      className="p-4 border border-gray-200 rounded-lg shadow-sm bg-white"
                    >
                      <h6 className="text-sm font-semibold text-gray-700 mb-3">
                        {category.hicategory}
                      </h6>
                      <div className="flex flex-col space-y-2">
                        {category.subCategories.map((subcategory) => (
                          <label
                            key={subcategory._id}
                            className="flex items-center gap-2 cursor-pointer text-sm text-gray-700"
                          >
                            <input
                              type="checkbox"
                              name="selectedHobbies"
                              value={subcategory._id}
                              onChange={formik.handleChange}
                              onBlur={formik.handleBlur}
                              checked={formik.values.selectedHobbies.includes(
                                subcategory._id
                              )}
                              className="form-checkbox h-4 w-4 text-indigo-600 cursor-pointer rounded"
                            />
                            {subcategory.hisubcategories}
                          </label>
                        ))}
                      </div>
                    </div>
                  )
              )}
            </div>
            {formik.errors.selectedHobbies && formik.touched.selectedHobbies && (
              <p className="text-xs text-red-500 mt-1">
                {formik.errors.selectedHobbies}
              </p>
            )}
          </>
        )}

        {/* Footer */}
        <div className="mt-6 flex items-center justify-between">
          <p className="text-xs text-gray-400">
            <span className="text-red-500">*</span> Required fields
          </p>
          <button
            type="submit"
            onClick={formik.handleSubmit}
            disabled={formik.isSubmitting}
            className="flex items-center gap-2 bg-indigo-600 hover:bg-indigo-700 disabled:opacity-60 disabled:cursor-not-allowed text-white text-sm font-medium px-5 py-2 rounded-md transition"
          >
            <FontAwesomeIcon
              icon={formik.isSubmitting ? faSpinner : faPaperPlane}
              className={formik.isSubmitting ? "animate-spin" : ""}
            />
            {formik.isSubmitting
              ? "Saving..."
              : type === "edit"
              ? "Update Profile"
              : "Submit"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddBrideGroomProfile;
